import React from 'react'
import PropTypes from 'prop-types'

import { isPresent } from '../../../lib/utils/collection'
import CardPreviewSkeleton from '../CardPreviewSkeleton/CardPreviewSkeleton'
import ListingCard from '../ListingCard'

const CardMapPreview = ({
  activeItem,
  handleOnSaveClick,
  removeMarkAsActive,
  isLoading
}) => {
  if (isLoading) {
    return <CardPreviewSkeleton />
  }

  return (
    isPresent(activeItem)
      ? (
        <ListingCard
          fixedWidth
          hideOutline
          listing={activeItem}
          removeMarkAsActive={removeMarkAsActive}
          onSave={handleOnSaveClick}
        />
      )
      : null
  )
}

CardMapPreview.propTypes = {
  activeItem: PropTypes.object,
  handleOnSaveClick: PropTypes.func.isRequired,
  removeMarkAsActive: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
}

export default CardMapPreview
